import type {
  ActionTaskInput,
  CodeTaskInput,
  ConditionalInput,
  ContinuousLoadingInput,
  DataConnectorInput,
} from '@automata/wfb-api';

import type { ContinuousLoadingProperties } from '../../../types';

type GetContinuousLoadingTaskProps = {
  taskId: string;
  labwareId: string;
  taskProperties: ContinuousLoadingProperties;
  childTasks: Array<
    | ActionTaskInput
    | CodeTaskInput
    | DataConnectorInput
    | ConditionalInput
    | ContinuousLoadingInput
  >;
};

export const getContinuousLoadingTask = ({
  taskId,
  labwareId,
  taskProperties,
  childTasks,
}: GetContinuousLoadingTaskProps): ContinuousLoadingInput => {
  // Convert additionalDataInputs from task properties to API format
  const additional_data_inputs: ContinuousLoadingInput['additional_data_inputs'] =
    [];

  if (taskProperties.additionalDataInputs) {
    for (const input of taskProperties.additionalDataInputs) {
      if (input.type === 'string') {
        additional_data_inputs.push({
          id: input.id,
          type: input.type,
          label: input.label,
          default_value: input.default_value,
          options: input.options,
        });
      } else if (input.type === 'integer') {
        additional_data_inputs.push({
          id: input.id,
          type: input.type,
          label: input.label,
          default_value: input.default_value,
          options: input.options,
        });
      } else if (input.type === 'float') {
        additional_data_inputs.push({
          id: input.id,
          type: input.type,
          label: input.label,
          default_value: input.default_value,
          options: input.options,
        });
      } else if (input.type === 'boolean') {
        additional_data_inputs.push({
          id: input.id,
          type: input.type,
          label: input.label,
          default_value: input.default_value,
          options: input.options,
        });
      }
    }
  }

  // Build tasks dictionary from all child tasks
  const tasks: ContinuousLoadingInput['tasks'] = {};
  for (const task of childTasks) {
    if (task.id) {
      tasks[task.id] = task;
    }
  }

  return {
    tasks,
    id: taskId,
    loaded_labware_id: labwareId,
    additional_data_inputs,
    type: 'continuous_loading',
    description: taskProperties.description,
  };
};
